import {
  ComponentPropsOptions,
  defineComponent,
  h
} from '@vue/composition-api';
import { BezierEdgeProps } from '../../types';
import { Position } from '../../types';
import BaseEdge from './BaseEdge.vue';
import { getBezierPath } from './utils';

const BezierEdge = defineComponent<BezierEdgeProps>({
  name: 'BezierEdge',
  props: [
    'sourcePosition',
    'targetPosition',
    'label',
    'labelStyle',
    'labelShowBg',
    'labelBgStyle',
    'labelBgPadding',
    'labelBgBorderRadius',
    'sourceY',
    'sourceX',
    'targetX',
    'targetY',
    'curvature',
    'markerEnd',
    'markerStart',
    'interactionWidth',
    'data'
  ] as ComponentPropsOptions<BezierEdgeProps>,

  setup(props, { attrs }) {
    return () => {
      const [path, labelX, labelY] = getBezierPath({
        ...props,
        sourcePosition: props.sourcePosition ?? Position.Bottom,
        targetPosition: props.targetPosition ?? Position.Top
      });

      return h(BaseEdge as any, {
        attrs: {
          path,
          labelX,
          labelY,
          ...attrs
        },

        props: props
      });
    };
  }
});

export default BezierEdge;
